import { Card, Button, Space, Upload, message } from 'antd';
import { FileImageOutlined, UploadOutlined } from '@ant-design/icons';
import { useMutation } from '@tanstack/react-query';
import { api } from '../../api/client';

interface Props {
  coverUrl: string | null;
  onSet: (mediaId: string, url: string) => void;
  onRemove: () => void;
}

/** 封面照片卡：上傳 / 更換 / 移除。 */
export default function CoverCard({ coverUrl, onSet, onRemove }: Props) {
  const upload = useMutation({
    mutationFn: (file: File) => api.uploadImage(file),
    onSuccess: ({ id, url }) => {
      onSet(id, url);
      message.success('封面已設定');
    },
    onError: (e: Error) => message.error(e.message),
  });

  return (
    <Card title="封面照片">
      {coverUrl ? (
        <img src={coverUrl} alt="封面" className="mb-2 aspect-[16/10] w-full rounded object-cover" />
      ) : (
        <div className="mb-2 flex aspect-[16/10] w-full items-center justify-center rounded bg-gray-100 text-3xl text-gray-300">
          <FileImageOutlined />
        </div>
      )}
      <Space>
        <Upload
          showUploadList={false}
          accept="image/*"
          beforeUpload={(file) => {
            upload.mutate(file);
            return false;
          }}
        >
          <Button icon={<UploadOutlined />} loading={upload.isPending}>
            {coverUrl ? '更換封面' : '上傳封面'}
          </Button>
        </Upload>
        {coverUrl && (
          <Button danger onClick={onRemove}>
            移除
          </Button>
        )}
      </Space>
    </Card>
  );
}
